import React, { useState } from "react";

import api, { handleApi } from "pages/api/api";

import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";

import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

import DialogSelecionarMateriais from "./DialogSelecionarMateriais";

export default function DialogCampanhaMaterial({
  PaperComponent,
  open,
  onClose,
  formMaterial,
  setFormMaterial,
  materialInput,
  setMaterialInput,
  materiaisCombo,
  carregarMateriaisCombo,
  materialLabel,
  guardarMaterial,
  form,
  materiaisCampanha,
  carregarMateriaisCampanha,
  showAlert,
  setLoading,
}) {
  const [openSelecionarMateriais, setOpenSelecionarMateriais] = useState(false);

  const confirmarSelecionarMateriais = async (materiais) => {
    if (!form?.id) {
      showAlert("Grava primeiro o cabeçalho da campanha.", "warning");
      return;
    }

    if (!materiais || materiais.length === 0) {
      showAlert("Seleciona pelo menos um material.", "warning");
      return;
    }

    setLoading(true);

    const [payload, err, meta] = await handleApi(
      api.post("Campanhas/InsCampanhaMateriaisLote", {
        idcampanha: form.id,
        materiais: materiais.map((m) => ({
          refmaterial: m.ref,
          qtd: Number(formMaterial.qtd || 1),
          unidade: m.refmaterialunidade || formMaterial.unidade || "",
          descprommaxfabricante:
            formMaterial.descprommaxfabricante === ""
              ? null
              : Number(formMaterial.descprommaxfabricante),
          obs: formMaterial.obs || "",
        })),
      })
    );

    setLoading(false);

    if (err) {
      showAlert(err, "error");
      return;
    }

    setOpenSelecionarMateriais(false);

    await carregarMateriaisCampanha(form.id);

    onClose();
    showAlert(meta?.message || "Materiais inseridos.", meta?.severity || "success");
  };

  return (
    <Dialog
      PaperComponent={PaperComponent}
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          width: { xs: "calc(100% - 24px)", sm: "600px" },
          maxWidth: "100%",
          m: { xs: 1.5, md: 3 },
        },
      }}
    >
      <DialogTitle id="draggable-dialog-title" style={{ cursor: "move" }}>
        {formMaterial.id ? "Editar material" : "Novo material"}
      </DialogTitle>

      <DialogContent
        sx={{
          px: { xs: 1.5, md: 3 },
        }}
      >
        <MDBox display="grid" gap={1.5} mt={1}>
          <div>
            <MDBox display="flex" justifyContent="space-between" alignItems="center" mb={0.5}>
              <div style={{ fontSize: 12, color: "#7b809a" }}>Material</div>

              <MDButton color="info" size="small" onClick={() => setOpenSelecionarMateriais(true)}>
                Selecionar vários
              </MDButton>
            </MDBox>

            <Autocomplete
              size="small"
              options={materiaisCombo}
              filterOptions={(x) => x}
              inputValue={materialInput}
              getOptionLabel={materialLabel}
              renderOption={(props, option) => (
                <li
                  {...props}
                  style={{
                    color: Number(option.inativo || 0) === 1 ? "#d32f2f" : undefined,
                    fontWeight: Number(option.inativo || 0) === 1 ? "bold" : undefined,
                  }}
                >
                  {materialLabel(option)}
                </li>
              )}
              value={materiaisCombo.find((m) => m.ref === formMaterial.refmaterial) || null}
              onInputChange={(_, value, reason) => {
                if (reason === "input") {
                  setMaterialInput(value);
                  setFormMaterial((p) => ({ ...p, refmaterial: "" }));
                  carregarMateriaisCombo(value);
                }

                if (reason === "clear") {
                  setMaterialInput("");
                  setFormMaterial((p) => ({ ...p, refmaterial: "" }));
                }
              }}
              onChange={(_, value) => {
                setFormMaterial((p) => ({
                  ...p,
                  refmaterial: value?.ref || "",
                  unidade: value?.refmaterialunidade || p.unidade,
                }));

                setMaterialInput(value ? materialLabel(value) : "");
              }}
              renderInput={(params) => <TextField {...params} placeholder="Selecione..." />}
            />
          </div>

          <MDBox
            display="grid"
            gridTemplateColumns={{ xs: "1fr", sm: "1fr 1fr", md: "1fr 1fr 1fr" }}
            gap={1.5}
          >
            <MDInput
              label="Quantidade"
              type="number"
              value={formMaterial.qtd}
              onChange={(e) => setFormMaterial((p) => ({ ...p, qtd: e.target.value }))}
              fullWidth
            />

            <MDInput
              label="Unidade"
              value={formMaterial.unidade}
              onChange={(e) => setFormMaterial((p) => ({ ...p, unidade: e.target.value }))}
              fullWidth
            />

            <MDInput
              label="Desc. máx. campanha (%)"
              type="number"
              value={formMaterial.descprommaxfabricante}
              onChange={(e) =>
                setFormMaterial((p) => ({
                  ...p,
                  descprommaxfabricante: e.target.value,
                }))
              }
              fullWidth
            />
          </MDBox>

          <MDInput
            label="Observações"
            value={formMaterial.obs}
            onChange={(e) => setFormMaterial((p) => ({ ...p, obs: e.target.value }))}
            fullWidth
            multiline
            rows={3}
          />
        </MDBox>
      </DialogContent>

      <DialogActions
        sx={{
          flexWrap: "wrap",
          gap: 1,
          px: { xs: 2, md: 3 },
          pb: { xs: 2, md: 2 },
          "& .MuiButton-root": {
            width: { xs: "100%", sm: "auto" },
          },
        }}
      >
        <MDButton color="secondary" onClick={onClose}>
          Cancelar
        </MDButton>

        <MDButton color="success" onClick={guardarMaterial}>
          Guardar
        </MDButton>
      </DialogActions>

      <DialogSelecionarMateriais
        open={openSelecionarMateriais}
        onClose={() => setOpenSelecionarMateriais(false)}
        materiaisCombo={materiaisCombo.filter(
          (m) => !(materiaisCampanha || []).some((a) => String(a.refmaterial) === String(m.ref))
        )}
        carregarMateriaisCombo={carregarMateriaisCombo}
        materialLabel={materialLabel}
        onConfirmar={confirmarSelecionarMateriais}
      />
    </Dialog>
  );
}
